export enum ESuccessModalType {
  Package = 'package', // Покупка пакета
  PackageWithHold = 'packageWithHold', // Покупка пакета с холдированием
  Subscription = 'subscription', // Покупка подписки
  SubscriptionWithHold = 'subscriptionWithHold', // Покупка подписки с холдированием
  PackageWithRedirect = 'packageWithRedirect', // Новая версия покупки пакета с редиректом на ФП
}
